import React, { useEffect, useRef, useState } from 'react';
import * as $3Dmol from '3dmol';

const MoleculeViewer = () => {
  const viewerRef = useRef(null);
  const viewerInstance = useRef(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const element = viewerRef.current;
    if (!element || viewerInstance.current) return;

    viewerInstance.current = $3Dmol.createViewer(element, {
      antialias: true,
      disableFog: true,
    });

    const viewer = viewerInstance.current;
    viewer.setBackgroundColor('#39355A');

    fetch('/cleaned.txt', { cache: 'no-store' })
      .then(res => {
        if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
        return res.text();
      })
      .then(molData => {
        viewer.addModel(molData, 'xyz');

        viewer.setStyle({}, { stick: { radius: 0.1 }, sphere: { scale: 0.25 } });

        viewer.setStyle({ elem: 'C' }, {
          stick: { radius: 0.15, color: '#3C325C' },
          sphere: { scale: 0.25, color: '#3C325C', alpha: 0.75 },
        });

        viewer.setStyle({ elem: 'Si' }, {
          stick: { radius: 0.1, color: '#F79A3E' },
          sphere: { scale: 0.25, color: '#F79A3E', alpha: 0.75 },
        });

        viewer.setStyle({ elem: 'H' }, {
          stick: { radius: 0.05, color: '#BBBBBB' },
          sphere: { scale: 0.175, color: '#BBBBBB', alpha: 0.25 },
        });

        viewer.zoomTo();
        viewer.render();
        viewer.spin(true);

        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to load molecule:', err);
        setError('Failed to load molecule.');
        setLoading(false);
      });

  }, []);

  return (
    <div
      ref={viewerRef}
      style={{
        width: '100%',
        height: '450px',
        margin: '0 auto',
        position: 'relative',
        backgroundColor: '#39355A',
        border: 'none',
        boxShadow: 'none',
      }}
    >
      {loading && (
        <div style={{
          color: '#FFFFFF',
          textAlign: 'center',
          paddingTop: '200px',
          fontSize: '18px',
        }}>
        </div>
      )}
      {error && (
        <div style={{
          color: 'red',
          textAlign: 'center',
          paddingTop: '200px',
          fontSize: '18px',
        }}>
          {error}
        </div>
      )}
    </div>
  );
};

export default MoleculeViewer;
